'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.typed-array.to-sorted');



// WEBPACK FOOTER //
// ./~/core-js/modules/esnext.typed-array.to-sorted.js